import axios from '../localAxios';
import { foldersURL } from './url';

/**
 * These are adapted from constants.js
 */
export enum FolderType {
  NO_FOLDER = 0,
  ROOT_FOLDER = null,
  TRASH = -1,
  QUIZ_FOLDER = 1,
  REPORT_FOLDER = 2,
  MAX_FOLDER_TREE_DEPTH = 6,
}

export interface CreateFolderResponse {
  id: number;
  name: string;
}

interface CreateFolderPayload {
  name: string;
  parentId: number;
  type: FolderType;
}

export type CreateFolderParameters = {
  name: string;
  parentId: number;
  type: FolderType;
};

export async function createFolder({
  name,
  parentId,
  type,
}: CreateFolderParameters) {
  const url = foldersURL();
  const data: CreateFolderPayload = {
    name,
    parentId,
    type,
  };
  const response = await axios.post<CreateFolderResponse>(url.href, data);
  return response.data;
}
